import React, { useEffect, useMemo, useState } from "react";
import {
  Col, Row, Card, CardBody, Badge, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Spinner, Alert, Input,
  UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import KullaniciIletisimModal from "../../../components/Common/KullaniciIletisimModal";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

// MEZAT_DURUM tablosu: 1 Başlayacak, 2 Canlı, 3 Biten, 4 Silindi (soft-delete),
// 5 Onay Bekliyor (yeni mezat; Onayla → 1, Reddet → 4 + hak iadesi).
const DURUMLAR = [
  { id: 5, ad: "Onay Bekliyor" },
  { id: 1, ad: "Başlayacak" },
  { id: 2, ad: "Canlı" },
  { id: 3, ad: "Biten" },
];

const fmtTL = (v) =>
  v == null || v === "" ? "-" : `${parseFloat(v).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺`;
const fmtTarih = (d) => (d ? new Date(d).toLocaleString("tr-TR") : "-");

const MezatYonetimi = () => {
  document.title = "Mezat Yönetimi | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = useMemo(() => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  }), [token]);

  const [mezatlar, setMezatlar] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  // ─── SİLİNENLER GÖRÜNÜMÜ ─────────────────────────────────────
  // Soft-delete: silinen mezat DB'den silinmez, DURUM_ID=4 (Silindi) olur.
  // Mezat + teklif geçmişi korunur. Mobil listeler DURUM_ID ne 4 filtreler;
  // burada normal görünümde gizlenir, "Silinenler" sekmesinde listelenir.
  const [showDeleted, setShowDeleted] = useState(false);

  const [detailModal, setDetailModal] = useState(false);
  // Mezat sahibine uyarı bildirimi / arama ("yanlış mezat açtın" vb.)
  const [iletisimMezat, setIletisimMezat] = useState(null);
  const [selectedMezat, setSelectedMezat] = useState(null);
  const [teklifler, setTeklifler] = useState([]);
  const [teklifLoading, setTeklifLoading] = useState(false);
  // Kazanan teklif "OdemeBekliyor" siparişi yaratıyor; ödemeyi admin onaylıyor.
  const [mezatSiparis, setMezatSiparis] = useState(null);
  const [odemeLoading, setOdemeLoading] = useState(false);
  const [durumLoading, setDurumLoading] = useState(false);
  const [uzatLoading, setUzatLoading] = useState(null); // uzatılmakta olan mezat ID'si

  const fetchMezatlar = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${BASE_URL}/MEZATLAR?$top=500&$orderby=ID desc&$expand=KULLANICILAR($select=ID,AD_SOYAD,Mail_Adress,CEP_NO),KATEGORILER($select=AD),MEZAT_DURUM`,
        { headers }
      );
      const result = await response.json();
      if (result && result.value) setMezatlar(result.value);
    } catch (err) {
      setError("Mezatlar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchMezatlar();
  }, []);

  const handleViewDetail = async (mezat) => {
    setSelectedMezat(mezat);
    setDetailModal(true);
    setTeklifLoading(true);
    setMezatSiparis(null);
    try {
      const [teklifRes, siparisRes] = await Promise.all([
        fetch(
          `${BASE_URL}/MEZAT_TEKLIFLERI?$filter=MEZAT_ID eq ${mezat.ID}&$orderby=TEKLIF_MIKTARI desc&$expand=KULLANICILAR($select=AD_SOYAD,Mail_Adress)`,
          { headers }
        ),
        fetch(
          `${BASE_URL}/SIPARIS?$filter=MEZAT_ID eq ${mezat.ID}&$orderby=ID desc&$top=1`,
          { headers }
        ),
      ]);
      const result = await teklifRes.json();
      setTeklifler(result?.value || []);
      const sipJson = await siparisRes.json().catch(() => ({}));
      setMezatSiparis(sipJson?.value?.[0] || null);
    } catch (err) {
      setTeklifler([]);
    } finally {
      setTeklifLoading(false);
    }
  };

  // ─── DURUM DEĞİŞTİR (elle) ───────────────────────────────────
  // Mezat/DurumGuncelle BITIS_TARIHI'ni her çağrıda now yapıyor; o yüzden
  // "bitir" dışındaki geçişlerde doğrudan PATCH kullanılıyor (handleRestore ile aynı).
  const handleDurumDegistir = async (m, yeniDurumId) => {
    if (Number(yeniDurumId) === m.DURUM_ID) return;
    setDurumLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/MEZATLAR(${m.ID})`, {
        method: "PATCH", headers,
        body: JSON.stringify({ DURUM_ID: Number(yeniDurumId) }),
      });
      if (!res.ok) { setError("Durum güncellenemedi."); return; }
      setSuccessMsg(`Mezat #${m.ID} durumu güncellendi.`);
      setSelectedMezat({ ...m, DURUM_ID: Number(yeniDurumId), MEZAT_DURUM: DURUMLAR.find(d => d.id === Number(yeniDurumId)) ? { ID: Number(yeniDurumId), AD: DURUMLAR.find(d => d.id === Number(yeniDurumId)).ad } : m.MEZAT_DURUM });
      fetchMezatlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setError("Durum güncellenemedi.");
    } finally {
      setDurumLoading(false);
    }
  };

  // ─── MEZAT ONAY / RED ────────────────────────────────────────
  // Mezat/OnayKarar: onayda DURUM 5→1 (başlangıç geçmişse 2 dk sonraya kayar),
  // redde 5→4 + mezat hakkı iadesi; iki durumda da satıcıya bildirim gider.
  const [onayLoading, setOnayLoading] = useState(null); // işlenen mezat ID'si
  const handleOnayKarar = async (m, onay) => {
    let not = "";
    if (onay) {
      if (!window.confirm(`#${m.ID} "${m.URUN_AD}" mezatı onaylansın mı?`)) return;
    } else {
      const g = window.prompt(`#${m.ID} "${m.URUN_AD}" reddedilecek. Satıcıya iletilecek gerekçe (boş bırakılabilir):`, "");
      if (g === null) return; // vazgeçti
      not = g;
    }
    setOnayLoading(m.ID);
    try {
      const res = await fetch(`${BASE_URL}/Mezat/OnayKarar`, {
        method: "POST", headers,
        body: JSON.stringify({ MezatId: m.ID, Onay: onay, Not: not }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.Message || data.message || "İşlem başarısız.");
        return;
      }
      setSuccessMsg(onay ? `Mezat #${m.ID} onaylandı.` : `Mezat #${m.ID} reddedildi, hak iade edildi.`);
      setDetailModal(false);
      fetchMezatlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setError("İşlem başarısız.");
    } finally {
      setOnayLoading(null);
    }
  };

  // ─── ÖDEME ONAYLA ────────────────────────────────────────────
  // Mezat/OdemeOnayla: satıcı cüzdanına net tutarı geçer, ODEME_YAPILDI=true,
  // siparişi "Onaylandı" yapıp kargo hattına alır. Yalnız OdemeBekliyor'da çalışır.
  const handleOdemeOnayla = async () => {
    if (!mezatSiparis?.ID) return;
    if (!window.confirm(`Sipariş #${mezatSiparis.ID} ödemesi onaylansın mı? Satıcı cüzdanına net tutar aktarılacak.`)) return;
    setOdemeLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/Mezat/OdemeOnayla`, {
        method: "POST", headers,
        body: JSON.stringify({ SiparisId: mezatSiparis.ID }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.message || data.Message || "Ödeme onayı başarısız.");
        return;
      }
      setSuccessMsg(`Sipariş #${mezatSiparis.ID} ödemesi onaylandı.`);
      handleViewDetail(selectedMezat);
      fetchMezatlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setError("Ödeme onayı sırasında hata oluştu.");
    } finally {
      setOdemeLoading(false);
    }
  };

  // ─── DELETE (soft) ────────────────────────────────────────────
  // Fiziksel silme yerine backend Mezat/SoftDelete → DURUM_ID=4 (Silindi).
  // Mezat ve teklif geçmişi korunur, listeden düşer, geri alınabilir.
  const handleDelete = async (id) => {
    if (!window.confirm("Bu mezatı silmek istediğinize emin misiniz? (Silinenler sekmesinden geri alabilirsiniz.)")) return;
    try {
      const res = await fetch(`${BASE_URL}/Mezat/SoftDelete`, {
        method: "POST", headers,
        body: JSON.stringify({ MezatId: id }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.message || data.Message || "Silme işlemi başarısız.");
        return;
      }
      setSuccessMsg("Mezat silindi (Silinenler sekmesinde).");
      fetchMezatlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setError("Silme sırasında hata oluştu.");
    }
  };

  // ─── RESTORE (geri yükle) ─────────────────────────────────────
  // Bitiş tarihi geçmişse 3 (Biten), aksi halde 1 (Başlayacak) — Hangfire
  // job zamanı gelince Canlı'ya (2) çeker, biz Canlı'ya elle çekmeyiz.
  const handleRestore = async (m) => {
    const bitis = m.BITIS_TARIHI ? new Date(m.BITIS_TARIHI) : null;
    const yeniDurum = bitis && bitis < new Date() ? 3 : 1;
    const etiket = yeniDurum === 3 ? "Biten" : "Başlayacak";
    if (!window.confirm(`Bu mezat geri yüklenecek (durum: ${etiket}). Devam edilsin mi?`)) return;
    try {
      const res = await fetch(`${BASE_URL}/MEZATLAR(${m.ID})`, {
        method: "PATCH", headers,
        body: JSON.stringify({ DURUM_ID: yeniDurum }),
      });
      if (!res.ok) { setError("Geri yükleme başarısız."); return; }
      setSuccessMsg(`Mezat geri yüklendi (${etiket}).`);
      fetchMezatlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setError("Geri yükleme başarısız.");
    }
  };

  // ─── MANUEL SONLANDIR (moderasyon) ───────────────────────────
  // Canlı/başlayacak bir mezatı admin elle bitirir: Mezat/DurumGuncelle → DURUM_ID=3 (Biten),
  // BITIS_TARIHI=now. Hangfire beklemeden yayını/teklifi kapatır (ör. kural ihlali).
  const handleSonlandir = async (m) => {
    if (!window.confirm(`Mezat #${m.ID} elle sonlandırılsın mı? (Durum "Biten" olur, teklif/yayın kapanır.)`)) return;
    try {
      const res = await fetch(`${BASE_URL}/Mezat/DurumGuncelle`, {
        method: "POST", headers,
        body: JSON.stringify({ MezatId: m.ID, DurumId: 3 }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(data.message || data.Message || "Sonlandırma başarısız.");
        return;
      }
      setSuccessMsg(`Mezat #${m.ID} sonlandırıldı (Biten).`);
      fetchMezatlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setError("Sonlandırma sırasında hata oluştu.");
    }
  };

  // ─── SÜRE UZAT (admin) ───────────────────────────────────────
  // /api/Mezat/Extend admin çağrısında hak DÜŞMEZ ve sahiplik aranmaz; sadece
  // canlı (DURUM_ID=2) mezatlar uzatılabilir. Backend SignalR "SureUzatildi"
  // yayınlar, izleyicilerin sayacı da senkron olur.
  // Teknik arıza / itiraz gibi durumlarda satıcının hakkını harcamadan ek süre.
  const handleUzat = async (m, dakika) => {
    if (m.DURUM_ID !== 2) {
      setError("Yalnızca canlı mezatlar uzatılabilir.");
      return;
    }
    if (!window.confirm(`Mezat #${m.ID} süresi ${dakika} dakika uzatılsın mı? (Satıcının hakkı düşmez.)`)) return;
    setUzatLoading(m.ID);
    try {
      const res = await fetch(`${BASE_URL}/api/Mezat/Extend`, {
        method: "POST", headers,
        body: JSON.stringify({ MezatId: m.ID, ExtendSeconds: dakika * 60 }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.Success) {
        setError(data.Message || data.message || "Süre uzatılamadı.");
        return;
      }
      setSuccessMsg(`Mezat #${m.ID} süresi ${dakika} dakika uzatıldı.`);
      fetchMezatlar();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch (err) {
      setError("Süre uzatma sırasında hata oluştu.");
    } finally {
      setUzatLoading(null);
    }
  };

  // ─── SÜRE / DURUM AYARLA (admin, moderasyon) ─────────────────
  // /api/AdminSure/Mezat — /api/Mezat/Extend'den farklı: mutlak bitiş tarihi
  // verilebilir, süre KISALTILABİLİR ve BİTMİŞ mezat yeniden canlıya alınabilir.
  // Ödemesi işlenmiş mezatta backend 409 döner; admin bilinçli onay verirse
  // OdemeliyiZorla ile devam edilir.
  const sureAyarla = async ({ mezatId, yeniBitisTarihi, ekDakika, canliyaAl, zorla = false }) => {
    setUzatLoading(mezatId);
    try {
      const res = await fetch(`${BASE_URL}/api/AdminSure/Mezat`, {
        method: "POST", headers,
        body: JSON.stringify({
          MezatId: mezatId,
          YeniBitisTarihi: yeniBitisTarihi || null,
          EkDakika: ekDakika ?? null,
          CanliyaAl: !!canliyaAl,
          OdemeliyiZorla: zorla,
        }),
      });
      const data = await res.json().catch(() => ({}));

      // Ödeme/sipariş uyarısı → adminden açık onay al, tekrar dene
      if (res.status === 409 && data.odemeVar && !zorla) {
        const devam = window.confirm(
          `${data.message}\n\n` +
          `Sipariş: #${data.siparisId ?? "—"} (${data.siparisDurumu ?? "—"})\n\n` +
          `Yine de mezatı yeniden açmak istiyor musunuz?`
        );
        if (!devam) return false;
        return await sureAyarla({ mezatId, yeniBitisTarihi, ekDakika, canliyaAl, zorla: true });
      }

      if (!res.ok || !data.basarili) {
        setError(data.message || data.Message || "Süre ayarlanamadı.");
        return false;
      }
      setSuccessMsg(data.mesaj || "Süre güncellendi.");
      fetchMezatlar();
      setTimeout(() => setSuccessMsg(""), 3000);
      return true;
    } catch (err) {
      setError("Süre ayarlama sırasında hata oluştu.");
      return false;
    } finally {
      setUzatLoading(null);
    }
  };

  // Biten/başlayacak mezatı yeniden canlıya al
  const handleCanliyaAl = async (m) => {
    const dk = window.prompt(
      `Mezat #${m.ID} yeniden CANLI yayına alınacak.\n\n` +
      `Kaç dakika süre verilsin?`,
      "30"
    );
    if (dk === null) return;
    const dakika = parseInt(dk, 10);
    if (!Number.isFinite(dakika) || dakika <= 0) {
      setError("Geçerli bir dakika girin.");
      return;
    }
    await sureAyarla({
      mezatId: m.ID,
      yeniBitisTarihi: new Date(Date.now() + dakika * 60000).toISOString(),
      canliyaAl: true,
    });
  };

  // Canlı mezatın bitiş saatini mutlak olarak değiştir (kısaltma dahil)
  const handleBitisDegistir = async (m) => {
    const mevcut = m.BITIS_TARIHI ? new Date(m.BITIS_TARIHI) : new Date();
    // datetime-local formatı: YYYY-MM-DDTHH:mm (yerel saat)
    const varsayilan = new Date(mevcut.getTime() - mevcut.getTimezoneOffset() * 60000)
      .toISOString().slice(0, 16);
    const girilen = window.prompt(
      `Mezat #${m.ID} yeni bitiş tarihi (yerel saat).\n` +
      `Format: YYYY-MM-DDTHH:mm\n\n` +
      `Not: Geçmiş bir saat girerseniz mezat ilk kontrolde kapanır.`,
      varsayilan
    );
    if (girilen === null) return;
    const d = new Date(girilen);
    if (isNaN(d.getTime())) {
      setError("Geçersiz tarih formatı.");
      return;
    }
    await sureAyarla({ mezatId: m.ID, yeniBitisTarihi: d.toISOString() });
  };

  const getDurumBadge = (status) => {
    const renkler = {
      "aktif": "success",
      "canlı": "success",
      "beklemede": "warning",
      "bekliyor": "warning",
      "başlayacak": "info",
      "onay bekliyor": "warning",
      "biten": "secondary",
      "bitti": "secondary",
      "iptal": "danger",
      "silindi": "dark",
    };
    return (
      <Badge color={renkler[status?.toLowerCase()] || "secondary"}>
        {status || "Bilinmiyor"}
      </Badge>
    );
  };

  // Silindi = DURUM_ID 4. Normal görünüm bunları gizler, Silinenler sekmesi gösterir.
  const isSilindi = (m) => m.DURUM_ID === 4;
  const silinenSayisi = useMemo(() => mezatlar.filter(isSilindi).length, [mezatlar]);
  const filteredMezatlar = useMemo(
    () => mezatlar.filter((m) => (showDeleted ? isSilindi(m) : !isSilindi(m))),
    [mezatlar, showDeleted]
  );

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => <span className="fw-bold">#{cell.getValue()}</span>,
    },
    {
      header: "Başlık",
      accessorKey: "URUN_AD",
      enableSorting: true,
      enableColumnFilter: true,
      cell: (cell) => (
        <div>
          <div className="fw-medium">{cell.getValue() || cell.row.original.AD || "-"}</div>
          <small className="text-muted">{cell.row.original.KATEGORILER?.AD || "Kategori Yok"}</small>
        </div>
      ),
    },
    {
      header: "Başlangıç Fiyatı",
      accessorKey: "BASLANGIC_FIYAT",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const val = cell.getValue();
        return val ? <span className="fw-medium">{parseFloat(val).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</span> : "-";
      },
    },
    {
      header: "Güncel Teklif",
      accessorKey: "GUNCEL_FIYAT",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const val = cell.getValue();
        return val ? (
          <span className="fw-bold text-success">
            {parseFloat(val).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺
          </span>
        ) : <span className="text-muted">Teklif Yok</span>;
      },
    },
    {
      header: "Satıcı",
      accessorKey: "KULLANICILAR",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cell) => {
        const u = cell.getValue();
        return u ? <span>{u.AD_SOYAD}</span> : "-";
      },
    },
    {
      header: "Bitiş Tarihi",
      accessorKey: "BITIS_TARIHI",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => {
        const d = cell.getValue();
        if (!d) return "-";
        const date = new Date(d);
        const now = new Date();
        const isExpired = date < now;
        return (
          <span className={isExpired ? "text-danger" : "text-success"}>
            {date.toLocaleDateString("tr-TR")}
            {isExpired && <i className="bx bx-time-five ms-1" title="Süresi doldu" />}
          </span>
        );
      },
    },
    {
      header: "Durum",
      accessorKey: "DURUM_ID",
      enableSorting: true,
      enableColumnFilter: false,
      cell: (cell) => getDurumBadge(cell.row.original.MEZAT_DURUM?.AD),
    },
    {
      header: "İşlemler",
      enableSorting: false,
      enableColumnFilter: false,
      cell: (cellProps) => {
        const m = cellProps.row.original;
        return (
          <div className="d-flex gap-2">
            <Button color="info" size="sm" outline title="Detay" onClick={() => handleViewDetail(m)}>
              <i className="bx bx-detail" />
            </Button>
            <Button color="primary" size="sm" outline title="Sahibine bildirim / ara" onClick={() => setIletisimMezat(m)}>
              <i className="bx bx-message-rounded-dots" />
            </Button>
            {showDeleted ? (
              <Button color="success" size="sm" title="Geri Yükle" onClick={() => handleRestore(m)}>
                <i className="bx bx-undo" />
              </Button>
            ) : (
              <>
                {m.DURUM_ID === 5 && (
                  <>
                    <Button color="success" size="sm" title="Onayla"
                      disabled={onayLoading === m.ID}
                      onClick={() => handleOnayKarar(m, true)}>
                      {onayLoading === m.ID ? <Spinner size="sm" /> : <><i className="bx bx-check" /> Onayla</>}
                    </Button>
                    <Button color="danger" size="sm" outline title="Reddet"
                      disabled={onayLoading === m.ID}
                      onClick={() => handleOnayKarar(m, false)}>
                      <i className="bx bx-x" /> Reddet
                    </Button>
                  </>
                )}
                {/* Süre uzatma sadece CANLI (2) mezatlarda anlamlı — backend de bunu şart koşuyor */}
                {m.DURUM_ID === 2 && (
                  <UncontrolledDropdown>
                    <DropdownToggle color="primary" size="sm" outline caret title="Süre Yönetimi" disabled={uzatLoading === m.ID}>
                      {uzatLoading === m.ID ? <Spinner size="sm" /> : <i className="bx bx-time-five" />}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem header>Hak düşmez (admin)</DropdownItem>
                      {[5, 15, 30, 60].map((dk) => (
                        <DropdownItem key={dk} onClick={() => handleUzat(m, dk)}>
                          +{dk} dakika
                        </DropdownItem>
                      ))}
                      <DropdownItem divider />
                      <DropdownItem header>Süreyi kısalt</DropdownItem>
                      {[5, 15].map((dk) => (
                        <DropdownItem key={`k${dk}`}
                          onClick={() => sureAyarla({ mezatId: m.ID, ekDakika: -dk })}>
                          −{dk} dakika
                        </DropdownItem>
                      ))}
                      <DropdownItem divider />
                      <DropdownItem onClick={() => handleBitisDegistir(m)}>
                        <i className="bx bx-calendar-edit me-1" />
                        Bitiş saatini gir…
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}

                {/* Biten (3) veya başlayacak (1) mezatı yeniden canlıya al.
                    Teknik arıza / yanlış kapanma durumları için. */}
                {(m.DURUM_ID === 3 || m.DURUM_ID === 1) && (
                  <Button color="success" size="sm" outline title="Yeniden Canlıya Al"
                    disabled={uzatLoading === m.ID}
                    onClick={() => handleCanliyaAl(m)}>
                    {uzatLoading === m.ID ? <Spinner size="sm" /> : <i className="bx bx-play-circle" />}
                  </Button>
                )}
                {/* Biten (3) veya Silindi (4) değilse manuel sonlandırılabilir */}
                {m.DURUM_ID !== 3 && m.DURUM_ID !== 4 && (
                  <Button color="warning" size="sm" title="Mezatı Bitir" onClick={() => handleSonlandir(m)}>
                    <i className="bx bx-stop-circle" />
                  </Button>
                )}
                <Button color="danger" size="sm" outline title="Sil" onClick={() => handleDelete(m.ID)}>
                  <i className="bx bx-trash" />
                </Button>
              </>
            )}
          </div>
        );
      },
    },
  ], [showDeleted, uzatLoading, onayLoading]);

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="HarmanaGEL" breadcrumbItem="Mezat Yönetimi" />

          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}

          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                      <h4 className="card-title mb-0">Mezatlar</h4>
                      <div className="btn-group btn-group-sm ms-2" role="group">
                        <Button
                          color={!showDeleted ? "primary" : "light"}
                          onClick={() => setShowDeleted(false)}
                        >
                          Aktif Mezatlar
                        </Button>
                        <Button
                          color={showDeleted ? "dark" : "light"}
                          onClick={() => setShowDeleted(true)}
                        >
                          <i className="bx bx-trash me-1" />
                          Silinenler{silinenSayisi > 0 ? ` (${silinenSayisi})` : ""}
                        </Button>
                      </div>
                    </div>
                    <Button color="primary" size="sm" onClick={fetchMezatlar} disabled={isLoading}>
                      <i className="bx bx-refresh me-1" />
                      Yenile
                    </Button>
                  </div>

                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={filteredMezatlar}
                      isGlobalFilter={true}
                      SearchPlaceholder="Mezat ara..."
                      isPagination={true}
                      isCustomPageSize={true}
                      tableClass="table-bordered align-middle nowrap w-100 mb-0"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Mezat Detay Modal */}
      <Modal isOpen={detailModal} toggle={() => setDetailModal(false)} size="xl" centered>
        <ModalHeader toggle={() => setDetailModal(false)}>
          Mezat #{selectedMezat?.ID} — {selectedMezat?.URUN_AD || selectedMezat?.AD}
        </ModalHeader>
        <ModalBody>
          {selectedMezat && (
            <>
              <Row className="mb-4">
                <Col md={4}>
                  {selectedMezat.MEZATLAR_Image ? (
                    <a href={selectedMezat.MEZATLAR_Image} target="_blank" rel="noreferrer">
                      <img
                        src={selectedMezat.MEZATLAR_Image}
                        alt={selectedMezat.URUN_AD || "Mezat"}
                        className="img-fluid rounded border mb-2"
                        style={{ maxHeight: 220, objectFit: "cover", width: "100%" }}
                      />
                    </a>
                  ) : (
                    <div className="border rounded d-flex align-items-center justify-content-center text-muted mb-2" style={{ height: 180 }}>
                      Görsel yok
                    </div>
                  )}
                  {selectedMezat.MEZAT_DETAY_ACIKLAMA && (
                    <div className="small text-muted" style={{ whiteSpace: "pre-wrap" }}>
                      {selectedMezat.MEZAT_DETAY_ACIKLAMA}
                    </div>
                  )}
                </Col>
                <Col md={8}>
                  <table className="table table-sm table-bordered mb-0">
                    <tbody>
                      <tr>
                        <th style={{ width: 170 }}>Satıcı</th>
                        <td>
                          {selectedMezat.KULLANICILAR?.AD_SOYAD || "-"}
                          {selectedMezat.KULLANICILAR?.Mail_Adress && (
                            <small className="text-muted d-block">{selectedMezat.KULLANICILAR.Mail_Adress}</small>
                          )}
                          <small className="text-muted">Kullanıcı ID: {selectedMezat.KIMDEN_ID ?? "-"}</small>
                        </td>
                      </tr>
                      <tr><th>Kategori</th><td>{selectedMezat.KATEGORILER?.AD || "-"} <small className="text-muted">(#{selectedMezat.KATEGORI_ID ?? "-"})</small></td></tr>
                      <tr><th>Konum</th><td>{[selectedMezat.KONUM_ILCE, selectedMezat.KONUM_IL].filter(Boolean).join(" / ") || "-"}{selectedMezat.Konum_Aciklama ? <small className="text-muted d-block">{selectedMezat.Konum_Aciklama}</small> : null}</td></tr>
                      <tr><th>Başlangıç Fiyatı</th><td>{fmtTL(selectedMezat.BASLANGIC_FIYAT)} <small className="text-muted">/ {selectedMezat.URUN_BIRIMI || "-"}</small></td></tr>
                      <tr>
                        <th>En Yüksek Teklif</th>
                        <td className="fw-bold text-success">{selectedMezat.GUNCEL_FIYAT ? fmtTL(selectedMezat.GUNCEL_FIYAT) : "Teklif yok"}</td>
                      </tr>
                      <tr><th>Başlangıç / Bitiş</th><td>{fmtTarih(selectedMezat.MEZAT_BASLANGIC_TARIHI)} → {fmtTarih(selectedMezat.BITIS_TARIHI)}</td></tr>
                      <tr><th>Toplam İzleyici</th><td>{selectedMezat.TOPLAM_IZLEYICI_SAYISI ?? "-"}</td></tr>
                      <tr><th>Kazanan</th><td>{selectedMezat.KAZANAN_ID ? `Kullanıcı #${selectedMezat.KAZANAN_ID}` : <span className="text-muted">Yok</span>}</td></tr>
                      <tr>
                        <th>Ödeme</th>
                        <td>
                          {selectedMezat.ODEME_YAPILDI
                            ? <Badge color="success">Ödendi</Badge>
                            : <Badge color="warning">Ödenmedi</Badge>}
                        </td>
                      </tr>
                      <tr><th>Teklife Açık</th><td>{selectedMezat.TEKLIF_ACIK === false ? "Hayır" : "Evet"}</td></tr>
                      <tr><th>Düzenleme Sayısı</th><td>{selectedMezat.DUZENLEME_SAYISI ?? 0}</td></tr>
                      <tr>
                        <th>Yayın</th>
                        <td className="small">
                          <div>Agora Room: {selectedMezat.AGORA_ROOM_ID || "-"}</div>
                          {selectedMezat.HLS_URL && <div>HLS: <a href={selectedMezat.HLS_URL} target="_blank" rel="noreferrer">aç</a></div>}
                          {selectedMezat.YAYIN_KAYIT_URL && <div>Kayıt: <a href={selectedMezat.YAYIN_KAYIT_URL} target="_blank" rel="noreferrer">izle</a></div>}
                        </td>
                      </tr>
                      <tr>
                        <th>Durum</th>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            {getDurumBadge(selectedMezat.MEZAT_DURUM?.AD)}
                            {selectedMezat.DURUM_ID !== 4 && (
                              <Input
                                type="select"
                                bsSize="sm"
                                style={{ maxWidth: 180 }}
                                value={selectedMezat.DURUM_ID || ""}
                                disabled={durumLoading}
                                onChange={(e) => handleDurumDegistir(selectedMezat, e.target.value)}
                              >
                                {DURUMLAR.map(d => (
                                  <option key={d.id} value={d.id}>{d.ad}</option>
                                ))}
                              </Input>
                            )}
                          </div>
                          <small className="text-muted">
                            Elle durum değişikliği bitiş tarihini değiştirmez. Yayını kapatmak için "Mezatı Bitir" kullanın.
                          </small>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>

              {/* Kazanan siparişi ve ödeme müdahalesi */}
              <div className="border rounded p-3 mb-4 bg-light">
                <h6 className="mb-2">Sipariş & Ödeme</h6>
                {mezatSiparis ? (
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className="small">
                      <div>Sipariş <strong>#{mezatSiparis.ID}</strong> — Durum: <Badge color={mezatSiparis.SIPARIS_DURUMU === "OdemeBekliyor" ? "warning" : "success"}>{mezatSiparis.SIPARIS_DURUMU === "OdemeBekliyor" ? "Ödeme Bekliyor" : mezatSiparis.SIPARIS_DURUMU}</Badge></div>
                      <div className="text-muted">
                        Toplam: {fmtTL(mezatSiparis.TOPLAM_TUTAR)} · Satıcıya net: {fmtTL(mezatSiparis.NET_TOPLAM ?? mezatSiparis.TOPLAM_TUTAR)}
                      </div>
                    </div>
                    {mezatSiparis.SIPARIS_DURUMU === "OdemeBekliyor" && (
                      <Button color="success" size="sm" onClick={handleOdemeOnayla} disabled={odemeLoading}>
                        {odemeLoading ? <Spinner size="sm" className="me-1" /> : <i className="bx bx-check-circle me-1" />}
                        Ödemeyi Onayla
                      </Button>
                    )}
                  </div>
                ) : (
                  <span className="text-muted small">Bu mezata bağlı sipariş yok (kazanan teklif kabul edilmemiş olabilir).</span>
                )}
              </div>

              <h6>Teklifler ({teklifler.length})</h6>
              {teklifLoading ? (
                <div className="text-center py-3"><Spinner color="primary" size="sm" /></div>
              ) : teklifler.length > 0 ? (
                <table className="table table-sm table-striped">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Kullanıcı</th>
                      <th>Teklif Tutarı</th>
                      <th>Tarih</th>
                    </tr>
                  </thead>
                  <tbody>
                    {teklifler.map((t, i) => (
                      <tr key={i} className={i === 0 ? "table-success fw-bold" : ""}>
                        <td>{i + 1}</td>
                        <td>{t.KULLANICILAR?.AD_SOYAD || `ID: ${t.KULLANICI_ID}`}</td>
                        <td>{parseFloat(t.TEKLIF_MIKTARI || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2 })} ₺</td>
                        <td>{t.TEKLIF_TARIHI ? new Date(t.TEKLIF_TARIHI).toLocaleString("tr-TR") : "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="text-muted text-center py-3">Henüz teklif yapılmamış.</p>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter className="justify-content-between">
          <div className="d-flex gap-2">
            {selectedMezat && selectedMezat.DURUM_ID !== 3 && selectedMezat.DURUM_ID !== 4 && (
              <Button color="warning" onClick={() => handleSonlandir(selectedMezat)}>
                <i className="bx bx-stop-circle me-1" /> Mezatı Bitir
              </Button>
            )}
            {selectedMezat && selectedMezat.DURUM_ID !== 4 && (
              <Button color="danger" outline onClick={() => { setDetailModal(false); handleDelete(selectedMezat.ID); }}>
                <i className="bx bx-trash me-1" /> Sil
              </Button>
            )}
            {selectedMezat && selectedMezat.DURUM_ID === 4 && (
              <Button color="success" onClick={() => { setDetailModal(false); handleRestore(selectedMezat); }}>
                <i className="bx bx-undo me-1" /> Geri Yükle
              </Button>
            )}
          </div>
          <Button color="secondary" outline onClick={() => setDetailModal(false)}>Kapat</Button>
        </ModalFooter>
      </Modal>

      <KullaniciIletisimModal
        isOpen={!!iletisimMezat}
        toggle={() => setIletisimMezat(null)}
        tip="MEZAT"
        ilgiliId={iletisimMezat?.ID}
        ilgiliBaslik={iletisimMezat?.URUN_AD}
        kullanici={iletisimMezat ? { ID: iletisimMezat.KIMDEN_ID, ...(iletisimMezat.KULLANICILAR || {}) } : null}
      />
    </React.Fragment>
  );
};

export default MezatYonetimi;
